import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { AppSettingCreateUpdateRequest, AppSettingGetResponseInfo } from '@models/app-settings.model';
import { AppSettingService } from '@services/app-setting/app-setting-service';
import { JapaneseLabels } from '@utils/japaneseLabels';


/**
 * SupportSettings component.
 * Handles the display and logic for the application's support settings page,
 * including editing terms, privacy policy, and legal information using a rich text editor.
 */
@Component({
  standalone: true,
  selector: 'app-support-settings',
  imports: [QuillModule, FormsModule],
  templateUrl: './support-settings.html',
  styleUrl: './support-settings.scss'
})
export class SupportSettings {

  constructor(private appSettingService: AppSettingService) { }
  // contentTerms !: string | null; //This will hold editor content
  contentPrivacy !: string;
  contentLaw !: string;
  contentUrl !: string;
  termsId?: string;
  privacyId?: string;
  urlId?: string;
  lawId?: string;
  contentTerms!: string;
  /** japan  text labels */
  japaneseLabel = JapaneseLabels;
  // termsId: string | null = null;
  // privacyId: string | null = null;
  // urlId: string | null = null;
  // lawId: string | null = null;

  /**
   * Angular lifecycle hook.
   * Initializes the editor content with default values.
   */
  ngOnInit() {
    this.doList();
  }



  /**
   * Submit settings form.
   *
   * Builds a payload containing terms, privacy, law and url settings and sends it
   * to the AppSettingService to create or update application settings.
   *
   * Shows a success alert on completion and logs errors to the console.
   */
  onSubmit() {
    const payload: AppSettingCreateUpdateRequest = {
      settings: [
        { setting_id: this.termsId, type: 'terms', value: this.contentTerms },
        { setting_id: this.privacyId, type: 'privacy', value: this.contentPrivacy },
        { setting_id: this.lawId, type: 'information', value: this.contentLaw },
        { setting_id: this.urlId, type: 'url', value: this.contentUrl }
      ]
    };

    this.appSettingService.orderCreate(payload).subscribe({
      next: (response) => {
        console.log('Settings updated successfully:', response);
        alert('設定が正常に更新されました。');
      },
      error: (err) => {
        console.error('Error updating settings:', err);
      },
      complete: () => {
        console.log('Update request completed.');
      }
    });
  }



  /**
   * Loads application settings from the server and populates editor fields and ids.
   * Populates contentTerms/contentPrivacy/contentUrl/contentLaw and their corresponding ids.
   */
  doList() {

    this.appSettingService.getAppSetting().subscribe({
      next: (response) => {
        console.log(response.app_setings);
        if (response.app_setings?.length > 0) {
          const terms: AppSettingGetResponseInfo | undefined = response.app_setings.find(x => x.type === 'terms');
          const privacy: AppSettingGetResponseInfo | undefined = response.app_setings.find(x => x.type === 'privacy');
          const url: AppSettingGetResponseInfo | undefined = response.app_setings.find(x => x.type === 'url');
          const law: AppSettingGetResponseInfo | undefined = response.app_setings.find(x => x.type === 'information');

          if (terms) {
            this.contentTerms = terms?.value;
          }
          if (privacy) {
            this.contentPrivacy = privacy?.value;
          }
          if (url) {
            this.contentUrl = url?.value;
          }
          if (law) {
            this.contentLaw = law?.value;
          }

          this.termsId = terms?.setting_id;
          this.privacyId = privacy?.setting_id;
          this.urlId = url?.setting_id;
          this.lawId = law?.setting_id;
        }
      },
      error: (err) => {
        console.error("Error", err);

      },
      complete: () => {

      }
    });
  }
}
